import {
  FooterWrapper,
  FooterInner,
  FooterContent,
  FooterSection,
  FooterTitle,
  FooterText,
  SocialLinks,
  SocialLink,
  SocialIcon,
  ContactInfo,
  LegalLinks,
  LegalLink,
  Copyright,
} from "./Footer.styles";

import iconInstagram from "images/icon_ig.png";
import iconX from "images/icon_x.png";
import iconYoutube from "images/icon_yt.png";
import iconDiscord from "images/icon_dc.png";
import iconSteam from "images/icon_st.png";
import iconLinkedin from "images/icon_in.png";
import iconEmail from "images/icon_email.png";

export const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      <FooterInner>
        <FooterContent>
          {/* Company Info */}
          <FooterSection>
            <FooterTitle>Telazer Games</FooterTitle>
            <FooterText>
              Creating engaging games that reach millions of players worldwide.
            </FooterText>
          </FooterSection>

          {/* Social Media Links */}
          <FooterSection>
            <FooterTitle>Follow Us</FooterTitle>
            <SocialLinks>
              <SocialLink
                href="https://www.youtube.com/@telazer"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialIcon src={iconYoutube} alt="YouTube" />
              </SocialLink>
              <SocialLink
                href="https://x.com/telazergames"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialIcon src={iconX} alt="X (Twitter)" />
              </SocialLink>
              <SocialLink
                href="https://discord.gg/RzX9ZGxAzd"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialIcon src={iconDiscord} alt="Discord" />
              </SocialLink>
              <SocialLink
                href="https://www.instagram.com/telazer_games/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialIcon src={iconInstagram} alt="Instagram" />
              </SocialLink>
              <SocialLink
                href="https://www.linkedin.com/company/telazer"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialIcon src={iconLinkedin} alt="LinkedIn" />
              </SocialLink>
              <SocialLink
                href="https://store.steampowered.com/app/3734200/Desktop_Heroes/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SocialIcon src={iconSteam} alt="Steam" />
              </SocialLink>
            </SocialLinks>
          </FooterSection>

          {/* Contact Info */}
          <FooterSection>
            <FooterTitle>Contact</FooterTitle>
            <ContactInfo>
              <SocialLink href="mailto:info@telazer.com">
                <SocialIcon src={iconEmail} alt="Email" />
                <span>info@telazer.com</span>
              </SocialLink>
              <FooterText>
                4 Peddlers Row #1153
                <br />
                Newark, DE 19702 US
                <br />
                +1 302 496 3536
              </FooterText>
            </ContactInfo>
          </FooterSection>

          {/* Legal Links */}
          <FooterSection>
            <LegalLinks>
              <LegalLink href="/privacy-policy">Privacy Policy</LegalLink>
              <LegalLink href="/terms-of-service">Terms of Service</LegalLink>
            </LegalLinks>
          </FooterSection>
        </FooterContent>

        {/* Copyright */}
        <Copyright>
          © {new Date().getFullYear()} Telazer Games. All rights reserved.
        </Copyright>
      </FooterInner>
    </FooterWrapper>
  );
};
